<template>
  <v-content style="height: 100%">
    <Header :title="section"></Header>

    <v-layout justify-center mt-5>
      <v-flex pa-4>

        <v-layout justify-space-between mb-7>
          <v-flex shrink>

            <v-layout v-if="section === 'jobs'">
              <v-flex pt-3 mr-4>
                อาชีพสร้างสรรค์ :
              </v-flex>
              <v-flex>
                <v-text-field
                        solo
                        flat
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout v-else-if="section === 'jobs-group'">
              <v-flex pt-3 mr-4>
                กลุ่มอาชีพสร้างสรรค์ :
              </v-flex>
              <v-flex>
                <v-text-field
                        solo
                        flat
                ></v-text-field>
              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex shrink>
            <InputForm :type="section"></InputForm>
          </v-flex>
        </v-layout>

        <!-- Loading overlay -->
        <loading :active.sync="sectionLoaded" :is-full-page="false" loader="bars"></loading>

        <v-layout v-if="section === 'jobs'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
                <tr>
                  <td>ลำดับ</td>
                  <td>ISCO08 Codes</td>
                  <td>อาชีพสร้างสรรค์</td>
                  <td>แก้ไข</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.</td>
                  <td>2161</td>
                  <td class="text-start">สถาปนิกก่อสร้าง (นักภูมิสถาปัตย์)</td>
                  <td><v-icon color="#FF4F23">edit</v-icon></td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>1221</td>
                  <td class="text-start">ผู้จัดการด้านการขายและการตลาด</td>
                  <td><v-icon color="#FF4F23">edit</v-icon></td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>1222</td>
                  <td class="text-start">ผู้จัดการด้านโฆษณาและประชาสัมพันธ์</td>
                  <td><v-icon color="#FF4F23">edit</v-icon></td>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>2432</td>
                  <td class="text-start">ผู้ประกอบวิชาชีพด้านการประชาสัมพันธ์</td>
                  <td><v-icon color="#FF4F23">edit</v-icon></td>
                </tr>
                <tr>
                  <td>5.</td>
                  <td>2431</td>
                  <td class="text-start">ผู้ประกอบวิชาชีพด้านโฆษณาและการตลาด</td>
                  <td><v-icon color="#FF4F23">edit</v-icon></td>
                </tr>
                <tr>
                  <td>6.</td>
                  <td>2164</td>
                  <td class="text-start">นักวางผังเมืองและระบบการจราจร</td>
                  <td><v-icon color="#FF4F23">edit</v-icon></td>
                </tr>
                <tr>
                  <td>7.</td>
                  <td>3112</td>
                  <td class="text-start">ช่างเทคนิคด้านวิศวกรรมโยธา</td>
                  <td><v-icon color="#FF4F23">edit</v-icon></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'jobs-group'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
              <tr>
                <td width="10%">ลำดับ</td>
                <td width="80%">กลุ่มอาชีพสร้างสรรค์</td>
                <td width="10%">แก้ไข</td>
              </tr>
              </thead>
              <tbody>

                <tr v-for="(item, i) in this.jobsGroupList.data" :key="i">
                  <td>{{item.id}}.</td>
                  <td class="text-start">{{item.name_th}}</td>
                  <td><InputForm :type="section" :edit="true" :param="item.id"></InputForm></td>
                </tr>

              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex shrink v-if="paginationJobsGroup.total > 0">
                <v-pagination v-model="paginationJobsGroup.current"
                              :length="paginationJobsGroup.total"
                              v-if="jobsGroupLoaded"
                              @input="onJobsGroupPageChange"
                              circle
                              color="#FF4F23"
                              :total-visible="pageVisible"
                ></v-pagination>
              </v-flex>
              <v-flex shrink mr-3 v-else>
                ไม่พบรายการข้อมูล
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>


      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
  import Header from '../components/Header'
  import InputForm from "../components/InputForm"
  import Service from '../services'
  import { mapState, mapActions } from 'vuex'
  import Loading from 'vue-loading-overlay'

export default {
  name: 'creative-jobs',
  props: ['section'],
  components: {
    Header,
    InputForm,
    Loading
  },
  data: () => ({
    dataParam: {},
    pageVisible: 8,
    paginationJobsGroup: {
      current: 1,
      total: 1,
      itemPerPage: 10
    },
    jobsGroupLoaded: false,
    sectionLoaded: true
  }),
  created() {
    this.dataParam.token = this.userData.token;
    this.onGetAllJobsGroupPaginate(this.dataParam).then(() => {
      this.onJobsGroupPageChange();
    })
  },
  watch: {
    // re-render pagination
    section: function () {
      this.jobsGroupLoaded = false;
      setTimeout(() => {
        this.jobsGroupLoaded = true;
      }, 1);
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      jobsGroupList: state => state.job.allJobsGroupPaginate
    })
  },
  methods: {
    ...mapActions('job',['onGetAllJobsGroupPaginate']),
    onJobsGroupPageChange(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationJobsGroup.total = Math.ceil(this.jobsGroupList.total / this.paginationJobsGroup.itemPerPage);

      Service.job.getAllJobsGroupPaginate(data).then((res) => {
        this.paginationJobsGroup.current = res.current_page;
        this.jobsGroupList.data = res.data;
        this.jobsGroupLoaded = true;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })

    }
  }
}
</script>

<style scoped>

  .theme--light.v-data-table thead tr td:not(:last-child),
  .theme--light.v-data-table tbody tr td:not(:last-child) {
    border-right: solid 1px #D7D7D7 !important;
  }

</style>
